import * as keyboardKey from 'keyboard-key';
import * as _ from 'lodash';
/**
 * @description
 * Adds role='button' to 'trigger' component's part, if it is not focusable element and no role attribute provided.
 * Adds tabIndex='0' to 'trigger' component's part, if it is not tabbable element and no tabIndex attribute provided.
 *
 * @specification
 * Adds attribute 'aria-disabled=true' to 'trigger' component's part based on the property 'disabled'.
 */
var popupBehavior = function (props) { return ({
    attributes: {
        trigger: {
            role: getAriaAttributeFromProps('role', props, 'button'),
            tabIndex: getAriaAttributeFromProps('tabIndex', props, '0'),
            'aria-disabled': !_.isNil(props['aria-disabled'])
                ? props['aria-disabled']
                : !!props['disabled'],
        },
    },
    keyActions: {
        popup: {
            closeAndFocusTrigger: {
                keyCombinations: [{ keyCode: keyboardKey.Escape }],
            },
        },
    },
}); };
var isFocusable = function (propsData) {
    try {
        var as = propsData.as, href = propsData.href, type = propsData.type;
        return (type === 'button' ||
            type === 'input' ||
            (type === 'a' && href !== undefined) ||
            as === 'button');
    }
    catch (_a) {
        return false;
    }
};
var getAriaAttributeFromProps = function (attributeName, props, defaultValue) {
    if (!props.trigger)
        return undefined;
    if (props.trigger.props[attributeName]) {
        return props.trigger.props[attributeName];
    }
    var _a = props.trigger.props, as = _a.as, href = _a.href;
    var type = props.trigger.type;
    if (isFocusable({ as: as, href: href, type: type })) {
        return undefined;
    }
    return defaultValue;
};
export default popupBehavior;
